export default __webpack_public_path__ + "static/media/flexibility-white.f281d32a.png";